/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 Trumpet.glb --transform 
Files: Trumpet.glb [36.32KB] > C:\Users\alexr\Documents\Development\Lofi site\public\Instruments\Trumpet-transformed.glb [4.28KB] (88%)
*/

import React, { useRef, useState } from "react";
import { useGLTF } from "@react-three/drei";
import { Sparkles } from "@react-three/drei";

export function Trumpet(props) {
  const { nodes, materials } = useGLTF("/Instruments/Trumpet-transformed.glb");
  const [sound, setSound] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const clickHandler = () => {
    console.log("clicked trumpet");
    if (isPlaying == false) {
      const sound = new Howl({
        src: "/sounds/trumpet.mp3",
        autoplay: false,
        volume: 0.3,
        onplay: () => {
          setIsPlaying(true);
          //requestAnimationFrame(step);
          // console.log(isPlaying);
          // console.log("on play");
          // requestAnimationFrame(step);
        },
        onend: () => {
          setIsPlaying(false);
        },
      });
      sound.play();

      setSound(sound);
    }
  };

  return (
    <group
      {...props}
      dispose={null}
      onClick={clickHandler}
      onPointerEnter={() => {
        document.body.style.cursor = "pointer";
      }}
      onPointerLeave={() => {
        document.body.style.cursor = "default";
      }}
    >
      {isPlaying && (
        <Sparkles
          count={100}
          scale={1}
          size={100}
          speed={2}
          color={"#00FF00"}
          position={[5.735, 4.352, -3.425]}
        />
      )}
      <mesh
        geometry={nodes.trumpet_Circle006.geometry}
        material={materials["FFEB3B.002"]}
        position={[5.735, 4.352, -3.425]}
        rotation={[Math.PI / 2, 0, -1.562]}
        scale={0.15}
      />
    </group>
  );
}

useGLTF.preload("/Instruments/Trumpet-transformed.glb");
